const headerContent = document.querySelector('.header__content');
const headerRight = document.querySelector('.header__right');
const positionHelper = document.querySelector('.header-position');

function setMaxWidthOfMenu() {
    const windowWidth = window.innerWidth;
    let maxWidth = null;
    if (windowWidth > positionHelper.offsetWidth) {
        maxWidth = windowWidth - headerRight.offsetWidth - positionHelper.offsetLeft + 'px';
    }
    headerContent.style.maxWidth = maxWidth;
}

if (headerRight && headerContent && positionHelper) {
    setMaxWidthOfMenu();

    // Setup a timer
    let timeout;

    // Listen for resize events
    window.addEventListener('resize', () => {
        // If there's a timer, cancel it
        if (timeout) {
            window.cancelAnimationFrame(timeout);
        }

        // Setup the new requestAnimationFrame()
        timeout = window.requestAnimationFrame(setMaxWidthOfMenu);
    });
}
